import { motion } from "framer-motion";
import { EASE } from "../../lib/api";

export const MaskLines = ({ lines, className = "", delay = 0, as = "h2", inView = false }) => {
  const Tag = motion[as];
  const trigger = inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" };
  return (
    <Tag className={className} initial="hide" {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em]">
          <motion.span
            className="block"
            variants={{ hide: { y: "110%" }, show: { y: "0%", transition: { duration: 1.2, ease: EASE, delay: delay + i * 0.14 } } }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, className = "", delay = 0, y = 28, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);
